module.exports = __webpack_public_path__ + "img/xinwen_img.c0b373ec.jpg";